function handleAjaxError() {
	statusDialog.hide();
	window.location.reload();
	//alert($('#ajax_error').text());
}
function handleAjaxSuccess() {
	statusDialog.hide();
	// If there are error messages, then scroll to the top
	// so the error messages come visible.
	var errorElt = $(".ui-messages-error"); 
	if (errorElt!=null && errorElt.data()!=null) {
		$('html, body').animate({scrollTop:0});
	}
	// If there are warning messages, then scroll to the top
	// so the warning messages come visible.
	var warningElt = $(".ui-messages-warn"); 
	if (warningElt!=null && warningElt.data()!=null) {
		$('html, body').animate({scrollTop:0});
	}
}

$(function() {
	$(".autofocus").focus();
})

// Override window.open. In ESIZE this function is often used in conjuction with
// creating an URL on the client. These URL's need to be signed to prevent parameter
// modifications.

var wo = window.open;

window.open = function() {
       if (arguments==null) {
              wo();
              return;
       }
       var url = arguments[0];
       if (url==null) {
              wo();
              return;
       }
       
       switch(arguments.length) {
              case 1:
                     wo(url);
                     break
              case 2:
                     wo(url,arguments[1]);
                     break;
              case 3:
                     wo(url,arguments[1],arguments[2]+',resizable=yes');
                     break;
              case 4:
                     wo(url,arguments[1],arguments[2]+',resizable=yes',arguments[3]);
                     break;
              case 5:
                     wo(url,arguments[1],arguments[2]+',resizable=yes',arguments[3],arguments[4]);
                     break;
              case 6:
                     wo(url,arguments[1],arguments[2]+',resizable=yes',arguments[3],arguments[4],arguments[5])
                     break;
              default:
                     break;
       }
}

function toggleBodyScrollBar() {
    $('html, body').toggleClass("no-scroll");
}

function updateCartBadgeCount(basketLink) {
    const element = document.getElementById('form-header-search:badge-line-item-count');
    const hiddenBadgeCounter = document.getElementById('header-buttons-form:cartBadgeCounter').value;
    if (element && hiddenBadgeCounter) {
        element.setAttribute('badge', hiddenBadgeCounter);

        if (hiddenBadgeCounter >= 0) {
            element.setAttribute('url', basketLink);
            element.removeAttribute('no-products-text');
        }
    }
}